import clsx from 'clsx';
import Card from '../../../components/Card';
import { formatPercentages, formatUSD } from '../../../helpers';
import useUserPoolPnl from '../../../hooks/web3/pools/useUserPoolPnl';

const PoolHistoricalPnl = () => {
    const { userPoolPnl } = useUserPoolPnl();

    return (
        <Card className='pool-historical-pnl'>
            <div className='title'>Historical PnL</div>
            <div
                className={clsx('value', {
                    increased: userPoolPnl && +userPoolPnl?.finalTotalPnl > 0,
                    decreased: userPoolPnl && +userPoolPnl?.finalTotalPnl < 0,
                })}
            >
                {userPoolPnl && +userPoolPnl?.finalTotalPnl > 0 && '+'}

                {userPoolPnl ? (
                    <>
                        {formatUSD(userPoolPnl.finalTotalPnl, { minDecimals: 2 })} (
                        {formatPercentages(userPoolPnl.finalTotalPnlPercentage)}%)
                    </>
                ) : (
                    '-'
                )}
            </div>
        </Card>
    );
};

export default PoolHistoricalPnl;
